<template>
  <Modal :value="value" @input="onModalInput">
    <p class="pb-2 text-xl font-bold leading-tight">
      {{ $t('popups.newVoucher.title') }}
    </p>

    <form @submit.prevent="onSubmit">
      <div
        v-for="(error, index) in errors"
        :key="index"
        class="w-full p-4 mt-2 mb-4 bg-sw_red_error-background"
      >
        <p class="pb-2 text-sm font-bold leading-none xl:text-lg">
          {{ $t(`errors.type.${error}.title`, brandInfo) }}
        </p>
        <p class="text-xs xl:text-sm" v-html="$t(`errors.type.${error}.description`, brandInfo)" />
      </div>

      <TextInput
        v-model="voucherCode"
        :placeholder="$t('components.form.flightvoucherCode.placeholder')"
        :label="$t('components.form.flightvoucherCode.label')"
        :error="$v.voucherCode.$error ? $t('components.form.error.voucherCode') : undefined"
        extra-class="mb-5"
      />

      <div class="flex flex-col-reverse justify-end pt-5 xl:flex-row xl:pt-8">
        <div class="mt-4 xl:mt-0 xl:mr-4">
          <Button
            :disabled="loading"
            variant="secondary"
            type="button"
            @click.prevent="close"
          >
            {{ $t('popups.newVoucher.button.close') }}
          </Button>
        </div>

        <div>
          <Button :loading="loading" type="submit">
            {{ $t('popups.newVoucher.button.submit') }}
          </Button>
        </div>
      </div>
    </form>
  </Modal>
</template>

<script>
import AddVoucherPopup from '~app/psp/base/add-voucher-popup.ts'

import Button from '~brand-components/swiss/button/button.vue'
import TextInput from '~brand-components/swiss/shared/text-input.vue'
import Modal from '~brand-components/swiss/modal/modal.vue'

export default AddVoucherPopup.extend({
  components: {
    Button,
    TextInput,
    Modal,
  },
})
</script>
